import { useState } from "react";
import { Box, Link, Typography } from "@mui/material"
import ComingSoonSnackbar from "../Utilities/ComingSoonSnackbar";

const PlatformBox = () => {
    const [comingSoonOpen, setComingSoonOpen] = useState(false);

    const items = [
      { label: "Web Terminal", href: "https://trade.hcfinvest.com/user/login" },
      { label: "Android App", href: "https://play.google.com/store/apps/details?id=com.metaquantpro.app" },
      { label: "iOS App", comingSoon: true },
    ];

    return (
      <Box
        sx={{
          width: { xs: "100%", sm: "90%", md: "310px" }, // fluid width for all devices
          maxWidth: "290px", // max width for larger screens
          p: 1,
          backgroundColor: "#f9f9f9",
          borderRadius: "20px",
          textAlign: "left",
          mx: "auto", // centers on smaller screens
        }}
      >
        {items.map((item, index) => (
          <Typography
            key={index}
            sx={{
              margin: "5px 0",
              padding: "5px",
              borderRadius: "5px",
              transition: "color 0.3s ease",
              "&:hover": {
                backgroundColor: "lightgray",
                borderRadius: "5px",
              },
            }}
          >
          {item.comingSoon ? (
            <Link
              underline="none"
              onClick={() => setComingSoonOpen(true)}
              sx={{
                textDecoration: "none",
                color: "black",
                cursor: "pointer",
              }}
            >
              {item.label}
            </Link>
          ) : (
            <Link
              underline="none"
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                textDecoration: "none",
                color: "black",
                cursor: "pointer",
              }}
            >
              {item.label}
            </Link>
          )}
          </Typography>
        ))}

        <ComingSoonSnackbar
          open={comingSoonOpen}
          onClose={() => setComingSoonOpen(false)}
          message="iOS App is launching soon — stay tuned!"
        />
      </Box>
    );
}
export default PlatformBox;
